import App from "../packages/site-search/App";
import { createRoot } from "react-dom/client";
const domNode = document.getElementById("react-site-search");
if (domNode) {
    const root = createRoot(domNode);
    root.render(<App />);
}
